export default __webpack_public_path__ + "static/multi-source-c760be90172154fe62ab5c2f3a03337a.png";